import React from 'react';
import { useShipForm } from '../../../context/shipForms';
import { ReferenceRouteFormDto } from '../../../types';
import { formatDateWithDashes } from '../../../utils/helper';
import edit from '../../../assets/icons/new_icon/edit-white.svg';

interface Props {
  setCurrentShipmentStatus: any;
  setEditRouteForm: any;
  setShowSummary: any;
  backRoute: any;
}
function ReferenceFields({
  setCurrentShipmentStatus,
  setEditRouteForm,
  setShowSummary,
  backRoute,
}: Props) {
  const {
    getReferenceFormDataContext,
    getPickupPayloadContext,
    getRatesApiPayloadContext,
  } = useShipForm();
  const referenceFormContextData: ReferenceRouteFormDto =
    getReferenceFormDataContext();
  const ratesPayloadContext: any = getRatesApiPayloadContext();

  return (
    <div className='h-100'>
      <div className='ubbe-card h-100'>
        <div className='ubbe-card-header d-flex justify-content-between'>
          <h5 className='ps-3 mb-0 GlobalBoxHead'>References</h5>
          <div
            className='my-auto'
            style={{ paddingRight: '20px' }}
          >
            <button
              type='button'
              className='editwhiteBg'
              onClick={() => {
                setCurrentShipmentStatus('select-route');
                setEditRouteForm(true);
              }}
            >
              <img
                src={edit}
                alt={edit}
              />
            </button>
          </div>
        </div>
        <div className='card-body pt-2 p-4 h-auto'>
          <div className='row '>
            <div className='col-6 col-md-6 col-lg-5 col-xl-4'>
              <label className='global-text-16'>Reference 1</label>
            </div>
            <div
              className='col-6 col-md-6 col-lg-7 col-xl-8 boldglobaltext'
              id='summary_reference_one'
            >
              {referenceFormContextData?.reference_1
                ? referenceFormContextData?.reference_1
                : 'N/A'}
            </div>
          </div>

          <div className='row mt-2'>
            <div className='col-6 col-md-6 col-lg-5 col-xl-4'>
              <label className='global-text-16'>Reference 2</label>
            </div>
            <div
              className='col-6 col-md-6 col-lg-7 col-xl-8 boldglobaltext'
              id='summary_reference_two'
            >
              {referenceFormContextData?.reference_2
                ? referenceFormContextData?.reference_2
                : 'N/A'}
            </div>
          </div>

          <div className='row mt-2'>
            <div className='col-6 col-md-6 col-lg-5 col-xl-4'>
              <label className='global-text-16'>Project</label>
            </div>
            <div
              className='col-6 col-md-6 col-lg-7 col-xl-8 boldglobaltext'
              id='summary_project'
            >
              {referenceFormContextData?.project_name
                ? referenceFormContextData?.project_name
                : 'N/A'}
            </div>
          </div>

          <div className='row mt-2'>
            <div className='col-6 col-md-6 col-lg-5 col-xl-4'>
              <label className='global-text-16'>Booking Date</label>
            </div>
            <div
              className='col-6 col-md-6 col-lg-7 col-xl-8 boldglobaltext'
              id='summary_date_time'
            >
              {ratesPayloadContext?.booking_date
                ? ratesPayloadContext?.booking_date
                : 'N/A'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReferenceFields;
